import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { LocationProp } from '../../models/Location';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';
import { ABUtils } from '../../utils';

class TopDestinationItem extends PureComponent {
    onClickItem = () => {
        const { index, item, onClickItem, trackEvent } = this.props;
        trackEvent({ action: 'recommended_destinations', label: 'rec_sel_home_' + (index + 1) });
        onClickItem(item);
    };

    render() {
        const { isCssVariationMobile } = ABUtils.getABs();
        const { item, isFixedWidth } = this.props;
        const countryStr = `, ${item.country}`;
        return (
            <DropdownItem
                onClick={this.onClickItem}
                iconClass='odf-icon-city odf-icon-bidi'
                isFixedWidth={isFixedWidth}
                iataCode={isCssVariationMobile ? item.iata : ''}
            >
                <span>{item.city}{countryStr}</span>
            </DropdownItem>
        );
    }
}

TopDestinationItem.propTypes = {
    index: PropTypes.number.isRequired,
    onClickItem: PropTypes.func.isRequired,
    item: LocationProp.isRequired,
    trackEvent: PropTypes.func.isRequired,
    isFixedWidth: PropTypes.bool,
};

TopDestinationItem.defaultProps = {
    isFixedWidth: false,
};

const connected = withPageContext(TopDestinationItem);
export { connected as TopDestinationItem };
